import { Space } from "antd";

function DraftsPageV2() {
  return (
    <Space direction={"vertical"}>
      <h1>Drafts</h1>
    </Space>
  );
}

export default DraftsPageV2;
